import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'
import zh from './locales/zh.json'
import da from './locales/da.json'

const messages = {
  en,
  de,
  zh,
  da
}

// Get saved language or default to browser language or English
const getSavedLanguage = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('lms-language')
    if (saved && messages[saved as keyof typeof messages]) {
      return saved
    }
    // Try to detect browser language
    const browserLang = navigator.language.split('-')[0]
    if (messages[browserLang as keyof typeof messages]) {
      return browserLang
    }
  }
  return 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: getSavedLanguage(),
  fallbackLocale: 'en',
  messages
})

export const availableLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' }
]

export default i18n
